import { Vue, Options } from 'vue-class-component';
import { getRandomInt } from '../../../core/utils/utils';

@Options({
  name: 'DialogConfirmDeletePlant',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    plantName: {
      type: String,
      required: true,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog', 'confirm'],
})
export default class DialogConfirmDeletePlant extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;
  codeToCheck = '';
  theCode = '';

  get isConfirmDisabled() {
    return this.theCode !== this.codeToCheck;
  }

  mounted() {
    this.isDialogVisible = this.isVisible;
    this.resetCodes();
  }

  handleHideDialog() {
    this.isDialogVisible = false;

    this.$nextTick(() => {
      this.resetCodes();
    });
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  doConfirm() {
    this.$emit('confirm');
    this.handleHideDialog();
  }

  resetCodes() {
    this.theCode = '';
    let randStr = ``;
    for (let i = 0; i < 4; i++) randStr += getRandomInt(0, 9, true);
    this.codeToCheck = randStr;
  }
}
